<script>
    export let title;
    export let subtitle = null;
    export let home = false;
</script>

<div class="page-header py-lg" class:home>
    <div class="container">
        <h1 class="title">{title}</h1>
        {#if subtitle}
            <div class="subtitle">{subtitle}</div>
        {/if}
    </div>
</div>

<style>
    .page-header {
        position: relative;
        background-size: cover;
        background-position: center center;
        background-image: url(/app/assets/images/bg-single-page.jpg);
    }

    .page-header:before {
        position: absolute;
        content: "";
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        pointer-events: none;
        background: rgba(1, 23, 42, 0.41);
    }

    .page-header .title {
        position: relative;
        color: #fff;
            margin: 0 0 20px 0;
        z-index: 999;
    }

    .page-header .subtitle {
        position: relative;
        font-size: 18px;
        font-style: italic;
        text-align: center;
        color: #fff;
    }

    .page-header.home {
        height: calc(100vh - 152px);
    }

    .page-header.home .title {
        text-align: center;
    }

    @media (max-width: 576px) {
        .page-header.home {
            height: calc(100vh - 53px);
        }
    }
</style>